import * as React from 'react';
import unless from 'ramda/src/unless';
import isNil from 'ramda/src/isNil';
import styled from '../styled-components';
import { mapMedia } from '../media';
import { StyledChildren } from '../StyledChildren';
var unlessNil = unless(isNil);
var SpaceImpl =
/*#__PURE__*/
styled(StyledChildren).withConfig({
  displayName: "Space__SpaceImpl",
  componentId: "sc-12v6d9d-0"
})(["", ";"], mapMedia(function (prop) {
  var m = unlessNil(function (value) {
    return {
      margin: value + 'px'
    };
  }, prop('margin'));
  var mx = unlessNil(function (value) {
    return {
      marginLeft: value + 'px',
      marginRight: value + 'px'
    };
  }, prop('marginHorizontal'));
  var my = unlessNil(function (value) {
    return {
      marginTop: value + 'px',
      marginBottom: value + 'px'
    };
  }, prop('marginVertical'));
  var ml = unlessNil(function (value) {
    return {
      marginLeft: value + 'px'
    };
  }, prop('marginLeft'));
  var mr = unlessNil(function (value) {
    return {
      marginRight: value + 'px'
    };
  }, prop('marginRight'));
  var mt = unlessNil(function (value) {
    return {
      marginTop: value + 'px'
    };
  }, prop('marginTop'));
  var mb = unlessNil(function (value) {
    return {
      marginBottom: value + 'px'
    };
  }, prop('marginBottom'));
  var p = unlessNil(function (value) {
    return {
      padding: value + 'px'
    };
  }, prop('padding'));
  var px = unlessNil(function (value) {
    return {
      paddingLeft: value + 'px',
      paddingRight: value + 'px'
    };
  }, prop('paddingHorizontal'));
  var py = unlessNil(function (value) {
    return {
      paddingTop: value + 'px',
      paddingBottom: value + 'px'
    };
  }, prop('paddingVertical'));
  var pl = unlessNil(function (value) {
    return {
      paddingLeft: value + 'px'
    };
  }, prop('paddingLeft'));
  var pr = unlessNil(function (value) {
    return {
      paddingRight: value + 'px'
    };
  }, prop('paddingRight'));
  var pt = unlessNil(function (value) {
    return {
      paddingTop: value + 'px'
    };
  }, prop('paddingTop'));
  var pb = unlessNil(function (value) {
    return {
      paddingBottom: value + 'px'
    };
  }, prop('paddingBottom'));
  return [m, mx, my, ml, mr, mt, mb, p, px, py, pl, pr, pt, pb];
}));

var Space = function Space(props) {
  return React.createElement(SpaceImpl, props);
};

export default Space;